import React from "react";
import { Lock, Database, Eye, Shield, Mail, Phone } from "lucide-react";
import { LegalLayout, LegalSection, CheckList } from "./legal/LegalLayout";

const PrivacyPolicy = () => (
  <LegalLayout
    eyebrow="Privacy & Security"
    eyebrowIcon={Lock}
    title="Privacy Policy"
    subtitle="Your privacy is fundamental to our Virtual Guard services. Learn how we protect and handle your information."
    updated="Last Updated: January 2025"
  >
    <div className="space-y-6">
      <LegalSection icon={Database} title="Information We Collect">
        <div>
          <h3 className="font-semibold text-[#1A1A1A] mb-2">Personal Information</h3>
          <p>We collect information you provide when requesting Virtual Guard consultations, including your name, email address, phone number, community/property details, and security concerns. This information helps us provide personalized virtual security solutions.</p>
        </div>
        <div>
          <h3 className="font-semibold text-[#1A1A1A] mb-2">Service Data</h3>
          <p>For active Virtual Guard clients, we collect security-related data necessary to provide remote monitoring services, including camera footage, access logs, incident reports, and property activity patterns.</p>
        </div>
        <div>
          <h3 className="font-semibold text-[#1A1A1A] mb-2">Website Usage</h3>
          <p>We automatically collect technical information about your website visits, including IP address, browser type, pages viewed, and interaction patterns to improve our virtual security platform.</p>
        </div>
      </LegalSection>

      <LegalSection icon={Eye} title="How We Use Your Information">
        <CheckList items={[
          "Provide dedicated Virtual Guard services and remote monitoring",
          "Process consultation requests and schedule virtual security assessments",
          "Generate security reports and incident documentation",
          "Communicate regarding your virtual security services and updates",
          "Improve our Virtual Guard platform and HOA community services",
          "Comply with legal requirements and Texas DPS licensing obligations",
        ]} />
      </LegalSection>

      <LegalSection icon={Shield} title="Data Protection & Security">
        <p>As a licensed security company (Texas DPS License #B30959201), we employ industry-standard security measures to protect your information:</p>
        <CheckList color="green" items={[
          "Encrypted data transmission and secure storage systems",
          "Access controls limiting data to authorized Virtual Guard personnel only",
          "Regular security audits and monitoring system updates",
          "Compliance with security industry standards and regulations",
        ]} />
      </LegalSection>

      <LegalSection title="Information Sharing">
        <p>We do not sell, trade, or rent your personal information to third parties. We may share information only in these limited circumstances:</p>
        <CheckList color="amber" items={[
          "With law enforcement when required by legal process or emergency situations",
          "With trusted service providers who assist in Virtual Guard operations under strict confidentiality",
          "With your HOA board or property management when providing contracted security services",
        ]} />
      </LegalSection>

      <LegalSection title="Your Privacy Rights">
        <p>You have the right to:</p>
        <CheckList color="blue" items={[
          "Access and review your personal information we have collected",
          "Request corrections to inaccurate or incomplete information",
          "Unsubscribe from marketing communications at any time",
          "Request deletion of your information (subject to legal and contractual obligations)",
        ]} />
      </LegalSection>

      <LegalSection title="Privacy Questions?" tone="accent">
        <p>For questions about this Privacy Policy or your personal information, contact us:</p>
        <div className="space-y-3 pt-1">
          <div className="flex items-center gap-3"><Mail className="w-5 h-5 text-[#D32F2F]" /><span className="font-semibold text-white">mike@redlinemonitoring.com</span></div>
          <div className="flex items-center gap-3"><Phone className="w-5 h-5 text-[#D32F2F]" /><span className="font-semibold text-white">(512) 363-6584</span></div>
        </div>
      </LegalSection>
    </div>
  </LegalLayout>
);

export default PrivacyPolicy;
